import { Component } from '@angular/core';

@Component({
    selector: 'address-blocks-list',
    templateUrl: 'address-blocks-list.component.html',
    styleUrls: ['address-blocks-list.component.scss'],
    standalone: false
})
export class AddressBlocksListComponent {}
